export enum LanguageVersion {
  en = 'en',
  de = 'de'
}
